import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(module)/user/[profileId]/loading.tsx");
